import Layers from "slotworks/graphics/layers/layers";
import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import DSComponents from "components/components";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import { CANVAS_SIZES } from "names/parrot-names";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SkipButtonBehaviour from "slotworks/smart-button/behaviours/skip-button-behaviour";
import { PotType } from "components/pots/coinpots-component";
import EnterFreespinsTransition from "transitions/enter-freespins-transitions";
import deviceInfo from "slotworks/utils/device-info";

export default class ICEnterFreespins extends EnterFreespins {

    public onEnter() {
        DSComponents.coinPots.burstCoins(PotType.FREESPIN).then(() => {
            if (campaignsModel.isFreespinsActive()) {
                for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
                    if ((mask & SmartButtonFlag.FREE_SPINS) > 0) {
                        smartButton.overrideBehaviour(mask, SkipButtonBehaviour);
                    }
                }
                smartButton.setFlag(SmartButtonFlag.AUTO_SPIN, false);
                Layers.SmartButton.hide();
                Layers.PromoBetBar.hide();
                Layers.BetBar.show();
            }
            if (Layers.CelebrationBackground.hasScene("glowstack")) {
                Layers.CelebrationBackground.setScene("glowstack").execute();
            }
            super.onEnter();
        });
    }

    public complete() {
        super.complete();
    }

    public onExit() {
        // EnterFreespinsTransition.playTorchAnimation()
        Layers.Custom.get("Torches").setScene("freespins").then(EnterFreespinsTransition.startTorch);
        deviceInfo.onLayoutChange.add(EnterFreespinsTransition.startTorch);
        DSComponents.coinPots.bankCoinsOnFreespin();
        Layers.CelebrationBackground.setScene("default").execute();
        super.onExit();
    }
}
